<template>
  <v-container id="regular-forms" fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="grey darken-3"
          icon="mdi-account-multiple"
          :title="formValues.first_name + ' ' + formValues.last_name"
          class="px-5 py-3"
        >
          <v-progress-linear
            indeterminate
            rounded
            height="6"
            v-if="loading"
          ></v-progress-linear>
          <div v-else>
            <p>
              <strong>{{ $t("address") }}: </strong>{{ formValues.address }},
              {{ formValues.plz }} {{ formValues.place }}
            </p>

            <p>
              <strong>{{ $t("tax") }}: </strong>{{ formValues.tax }}
            </p>
            <p>
              <strong>{{ $t("language") }}: </strong>{{ $t(formValues.lang) }}
            </p>

            <p v-if="formValues.phone">
              <strong>{{ $t("phone") }}: </strong
              ><a :href="'tel:' + formValues.phone">{{ formValues.phone }}</a>
            </p>
            <p v-if="formValues.email">
              <strong>{{ $t("email") }}: </strong
              ><a :href="'mailto:' + formValues.email">{{
                formValues.email
              }}</a>
            </p>
            <p>
              <strong>{{ $t("Children") }}: </strong>
              <template v-for="(child, index) in formValues.childrens">
                <v-chip
                  class="mr-1"
                  dark
                  @click="$router.push({ path: '/be/child/' + child.id })"
                  :key="index"
                  >{{ child.first_name }}
                  {{ child.last_name }}
                </v-chip>
              </template>
            </p>
            <hr />
            <v-tabs
              v-model="tab"
              background-color="gray"
              class="mt-2"
              dark
              right
            >
              <v-tab key="actual">{{
                $t("course_registrations_actual")
              }}</v-tab>
              <v-tab key="history">{{
                $t("course_registrations_history")
              }}</v-tab>
              <v-tab-item key="actual">
                <v-card class="pa-2 mt-0">
                  <v-card-text>
                    <template v-if="formValues.childrens">
                      <h4>
                        <strong
                          >{{ $t("course_registrations_actual") }}:
                        </strong>
                      </h4>
                      <v-alert type="info"
                        >{{ $t("course_registrations_actual_info") }}:</v-alert
                      >
                      <template v-for="(child, index) in formValues.childrens">
                        <template v-if="child.course_weeks.length">
                          <v-card
                            color="grey lighten-3"
                            class="mt-3 pa-2"
                            :key="'_' + index"
                          >
                            <h4 class="mb-2" dark>
                              {{ child.first_name }}
                              {{ child.last_name }}:
                            </h4>
                            <ul>
                              <template
                                v-for="(week, index) in child.course_weeks"
                              >
                                <li v-if="week.course.active" :key="index">
                                  <a @click="showCourse(week.course)"
                                    >{{ week.course.name }} -
                                    {{ week.name }} [{{
                                      week.from | formatDate
                                    }}
                                    - {{ week.to | formatDate }}]
                                    <strong v-if="week.pivot.is_waiting">
                                      !!
                                      {{ $t("course_waiting_list") }}</strong
                                    ></a
                                  >
                                </li>
                              </template>
                            </ul>
                          </v-card>
                        </template>
                      </template>
                    </template>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item key="history">
                <v-card class="pa-2 mt-0">
                  <v-card-text>
                    <template v-if="formValues.childrens">
                      <h4>
                        <strong
                          >{{ $t("course_registrations_history") }}:
                        </strong>
                      </h4>
                      <v-alert type="info"
                        >{{ $t("course_registrations_history_info") }}:</v-alert
                      >
                      <template v-for="(child, index) in formValues.childrens">
                        <template v-if="child.course_weeks.length">
                          <v-card
                            color="grey lighten-3"
                            class="mt-3 pa-2"
                            :key="'_' + index"
                          >
                            <h4 class="mb-2" dark>
                              {{ child.first_name }}
                              {{ child.last_name }}:
                            </h4>
                            <ul>
                              <template
                                v-for="(week, index) in child.course_weeks"
                              >
                                <li v-if="!week.course.active" :key="index">
                                  <a @click="showCourse(week.course)"
                                    >{{ week.course.name }} -
                                    {{ week.name }} [{{
                                      week.from | formatDate
                                    }}
                                    - {{ week.to | formatDate }}]
                                    <strong v-if="week.pivot.is_waiting">
                                      !!
                                      {{ $t("course_waiting_list") }}</strong
                                    ></a
                                  >
                                </li>
                              </template>
                            </ul>
                          </v-card>
                        </template>
                      </template>
                    </template>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </div>
          <v-card-actions class="pl-0">
            <v-btn class="mr-4" @click="$router.push({ name: 'person.index' })">
              {{ $t("back") }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" class="mr-4" @click="editItem(formValues)">
              {{ $t("edit") }}
            </v-btn>
          </v-card-actions>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { saveItem, fetchItem } from "../shared/services";
export default {
  name: "app-person-item",
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      formValues: {},
      permissions: [],
      loading: true,
      tab: "",
      genders: [
        {
          id: "m",
          name: this.$t("men")
        },
        {
          id: "f",
          name: this.$t("woman")
        },
        {
          id: "s",
          name: this.$t("divers")
        }
      ],
      languages: [
        {
          id: "de",
          name: this.$t("de")
        },
        {
          id: "it",
          name: this.$t("it")
        }
      ],
      headers: [
        {
          text: "Name",
          align: "left",
          value: "name"
        },
        { text: "Email", value: "email" },
        { text: "", value: "action", sortable: false }
      ]
    };
  },
  mounted() {
    if (this.$route.params.id) {
      if (this.$route.name === "person.show") {
        this.edit = false;
      } else {
        this.edit = true;
      }
      this.loading = true;
      fetchItem(this.$route.params.id).then(res => {
        this.formValues = res.data;
        this.loading = false;
      });
    } else {
      this.formValues.parent = true;
      this.loading = false;
    }
  },
  computed: {
    computedFormValues() {
      return {
        ...this.formValues
      };
    }
  },
  methods: {
    async saveItem() {
      this.$validator.reset();
      this.$validator.validateAll();
      let resp = await saveItem(
        this.$route.params.id,
        this.computedFormValues,
        this.$validator
      );
      if (resp.success) {
        this.$root.$notification(resp.message, { type: "success" });
        this.$router.push({ name: "person.index" });
      }
    },
    editItem(item) {
      let url = item.id;
      this.$router.push({
        name: "person.edit",
        params: { id: url }
      });
    },
    showCourse(item) {
      let url = item.id;
      this.$router.push({
        name: "course.show",
        params: { id: url }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
